if (!customElements.get('home-activity')) {
  customElements.define('home-activity', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.timers = [];
      const text = (node, selector) => node.querySelector(selector)?.textContent.trim() || '';
      const root = document.querySelector('template[data-review-details]')?.content;
      const track = this.querySelector('[data-feed="reviews"] .activity-track');
      const seen = new Set();
      const reviews = [...(root?.querySelectorAll('.jdgm-rev') || [])].sort((a,b) => (b.querySelector('.jdgm-rev__timestamp')?.getAttribute('data-content') || '').localeCompare(a.querySelector('.jdgm-rev__timestamp')?.getAttribute('data-content') || ''));
      for (const review of reviews) {
        const body = text(review,'.jdgm-rev__body');
        const author = text(review,'.jdgm-rev__author');
        if (!body || seen.has(author + body)) continue;
        seen.add(author + body);
        const item = document.createElement('li');
        const meta = document.createElement('div');
        meta.className = 'activity-review-meta';
        const rating = Number(review.querySelector('[data-score]')?.getAttribute('data-score'));
        if (rating >= 1 && rating <= 5) {
          const stars = document.createElement('div');
          stars.className = 'activity-stars';
          stars.textContent = '\u2605'.repeat(Math.round(rating)) + '\u2606'.repeat(5 - Math.round(rating));
          stars.setAttribute('aria-label', `${rating} out of 5 stars`);
          meta.append(stars);
        }
        const quote = document.createElement('blockquote');
        quote.textContent = body;
        quote.title = body;
        const name = document.createElement('p');
        name.className = 'activity-author';
        name.textContent = author;
        meta.append(name);
        item.append(meta,quote);
        track.append(item);
      }
      for (const column of this.querySelectorAll('.activity-column')) {
        const list = column.querySelector('ol');
        const count = list.children.length;
        column.querySelector('.activity-empty').hidden = count > 0;
        if (count < 5) continue;
        let animation = null;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        column.addEventListener('mouseenter', () => animation?.pause());
        column.addEventListener('mouseleave', () => animation?.play());
        column.addEventListener('focusin', () => animation?.pause());
        column.addEventListener('focusout', () => animation?.play());
        this.timers.push(setInterval(() => {
          if (animation || motion.matches || document.hidden || column.matches(':hover,:focus-visible') || column.querySelector(':focus-visible')) return;
          const first = list.firstElementChild;
          const ghost = count === 5 ? first.cloneNode(true) : null;
          if (ghost) { ghost.setAttribute('aria-hidden', 'true'); list.append(ghost); }
          animation = list.animate([{transform:'translateY(0)'},{transform:`translateY(-${first.getBoundingClientRect().height}px)`}], {duration:1000,easing:'ease-in-out'});
          animation.onfinish = () => {
            ghost?.remove();
            list.append(first);
            animation.cancel();
            animation = null;
          };
        }, 4000));
      }
    }
    disconnectedCallback() { this.timers?.forEach(clearInterval); }
  });
}
